export default function FilterChips({ selected, onChange, options }) {
  const toggleFilter = (value) => {
    if (selected.includes(value)) {
      onChange(selected.filter(v => v !== value));
    } else {
      onChange([...selected, value]);
    }
  };

  // Get color styles based on filter type
  const getChipStyles = (value, isSelected) => {
    const isDem = value.includes('D');
    const isRep = value.includes('R');
    const isTossup = value === 'Toss-Up';

    if (isSelected) {
      if (isDem) return 'bg-blue-600 text-white border-blue-400 shadow-blue-500/30 shadow-lg';
      if (isRep) return 'bg-red-600 text-white border-red-400 shadow-red-500/30 shadow-lg';
      if (isTossup) return 'bg-purple-600 text-white border-purple-400 shadow-purple-500/30 shadow-lg';
      return 'bg-accent-blue-dark text-white border-accent-blue';
    }

    // Unselected states with subtle color hints
    if (isDem) return 'bg-blue-900/30 text-blue-300 border-blue-700/50 hover:border-blue-500 hover:bg-blue-800/40';
    if (isRep) return 'bg-red-900/30 text-red-300 border-red-700/50 hover:border-red-500 hover:bg-red-800/40';
    if (isTossup) return 'bg-purple-900/30 text-purple-300 border-purple-700/50 hover:border-purple-500 hover:bg-purple-800/40';
    return 'bg-slate-800/50 text-slate-300 border-slate-600 hover:border-slate-500';
  };

  return (
    <div className="flex flex-wrap gap-1.5 sm:gap-2">
      {options.map(option => {
        const isSelected = selected.includes(option.value);
        return (
          <button
            key={option.value}
            onClick={() => toggleFilter(option.value)}
            className={`
              px-2.5 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold transition-all min-h-[36px] sm:min-h-[44px] border
              ${getChipStyles(option.value, isSelected)}
              ${isSelected ? 'scale-105' : 'hover:scale-[1.02]'}
              active:scale-95
            `}
            aria-pressed={isSelected}
            aria-label={`${isSelected ? 'Remove' : 'Add'} filter: ${option.label}`}
          >
            {isSelected && <span className="mr-1">✓</span>}
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
